import React, { FC } from "react";

const Currency: FC<{ value: number }> = ({ value }) => (
  <>{`${String(value).replace(".", ",")},-`}</>
);

export default Currency;
